import classNames from 'clsx';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { CasinoGameIcon, CasinoGameList, CasinoSliderButtons } from '@swf/casino';
import type { SliderHandles, State as SliderState } from '@swf/components/Slider/Slider';
import { select } from '@swf/core/store';
import type { CasinoGame } from '@swf/core/types/CasinoGame';
import { Category } from '@swf/core/types/StarsCoinReward';

import Container from '../Container/Container';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import containerStyles from '../Container/Container.scss';
import type WithClose from '../WithClose';

import styles from './FreeSpins.scss';

interface Props extends WithClose {
  games: CasinoGame[];
}

const FreeSpins: React.FC<Props> = ({ games, close }) => {
  const sliderRef = React.createRef<SliderHandles>();
  const [sliderState, setSliderState] = useState<SliderState>({ left: false, right: false });
  const isMobile = useSelector(select.device.isMobile);

  return (
    <Container
      allowOverflowRight
      category={Category.FSB}
      className={classNames(styles.container, {
        [styles.mobile]: isMobile,
        [containerStyles.mobile]: isMobile
      })}
      right={!isMobile && <CasinoSliderButtons sliderRef={sliderRef} sliderState={sliderState} />}
      close={isMobile ? close : <div />}
    >
      <CasinoGameList
        className={classNames(styles.gameList, { [styles.mobile]: isMobile })}
        fsbLaunch
        placeholder={<CasinoGameIcon images={{}} FSBPlaceholder />}
        games={games}
        icon="icnSquare"
        onScroll={setSliderState}
        preload
        tilesPerRow={5}
        sliderRef={sliderRef}
      />
    </Container>
  );
};

export default FreeSpins;
